export default __webpack_public_path__ + "static/media/bird_dark_female.7987f6d7.png";